import { z } from "zod";
export const orderPrintSettingsSchema = z.object({
    companyName: z.string().trim().min(1, "请输入店铺名称").max(80, "店铺名称最多 80 个字"),
    documentTitle: z.string().trim().min(1, "请输入单据名称").max(20, "单据名称最多 20 个字"),
    address: z.string().trim().max(200, "店铺地址最多 200 个字"),
    phones: z.string().trim().max(180, "店铺电话最多 180 个字"),
    fax: z.string().trim().max(80, "传真最多 80 个字"),
    headerNote: z.string().trim().max(200, "其他店铺资料最多 200 个字"),
    copyLabels: z.string().trim().max(80, "联次说明最多 80 个字"),
    fixedNote: z.string().trim().max(500, "固定备注最多 500 个字"),
    signatureLabels: z.string().trim().max(100, "签字栏最多 100 个字"),
    fontSize: z.enum(["8", "9", "10"]),
    density: z.enum(["compact", "standard"]),
    borderStyle: z.enum(["dotted", "solid"]),
}).strict();
// Initial text transcribed from the shop's supplied reference; all of it is editable.
export const defaultOrderPrintSettings = {
    companyName: "阳江市龙杰贸易有限公司", documentTitle: "送货单",
    address: "阳江市建设一路15号",
    phones: "(0662) 3104288  3104188  3104263  3103289", fax: "(0662) 3104388",
    headerNote: "", copyLabels: "1. 存根    2. 顾客    3. 回单",
    fixedNote: "非质量问题15天内凭单九折退换，非常规订货商品恕不退换。",
    signatureLabels: "欠款人、制单、出仓、复核、送货",
    fontSize: "9", density: "compact", borderStyle: "dotted",
};
export const saveOrderPrintSettingsSchema = z.object({
    settings: orderPrintSettingsSchema,
    revision: z.number().int().nonnegative(),
}).strict();
export const ORDER_PRINT_ITEMS_PER_DOCUMENT = 15;
export const createOrderPrintBatchSchema = z.object({
    idempotencyKey: z.uuid(),
    pages: z.array(z.object({
        itemIds: z.array(z.uuid()).max(ORDER_PRINT_ITEMS_PER_DOCUMENT),
        totalCents: z.number().int().nonnegative().max(2147483647),
        note: z.string().max(10000),
    }).strict()).min(1).max(200),
}).strict();
